<template>
  <div class="organisation-list container">
    <div v-if="isFetchingUnits">
      <v-skeleton-loader type="list-item" v-for="i in 5" :key="i" />
    </div>
    <div v-else>
      <OrganisationUnitItem
        :toggledByFilter="Boolean(searchText)"
        :isArchive="isArchive"
        v-for="unit in filteredUnits"
        :key="unit.id"
        :unit="unit"
        @update="fetchUnits"
      />
    </div>
    <BaseFooter v-if="!isArchive">
      <Permissioned section="settings" class="d-flex actions-bar">
        <BaseAction>
          <CreateUnitDialog v-if="open" :open="open" @close="open = false" />
          <SecondaryButton
            @click="open = true"
            permission="create-organisation-unit"
            color="primary"
          >
            <v-icon>
              mdi-cube-outline
            </v-icon>
            New Org Unit
          </SecondaryButton>
        </BaseAction>
      </Permissioned>
    </BaseFooter>
  </div>
</template>

<script>
import { ORGANISATION_UNITS_NAMESPACE } from "@/store/modules/organisations/organisation-units";
import { copyState } from "@/utils/helpers";
import { createNamespacedHelpers } from "vuex";
import {
  FETCH_ORGANISATION_UNITS,
  FETCH_ARCHIVED_UNITS
} from "@/store/modules/organisations/organisation-units/actions";
import OrganisationUnitItem from "@/views/settings/Organisation/Units/OrganisationUnitItem";
import {
  filterDeep,
  getOrganisationsAsTreeStructure
} from "@/utils/organisation-units";
import BaseFooter from "@/components/common/BaseFooter";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import CreateUnitDialog from "@/views/settings/Organisation/Units/dialogs/CreateUnitDialog";
import Permissioned from "@/components/common/Permissioned";
import BaseAction from "@/components/common/BaseAction";

const {
  mapActions: mapOrganisationUnitsActions,
  mapState: mapOrganisationUnitsState
} = createNamespacedHelpers(ORGANISATION_UNITS_NAMESPACE);

export default {
  name: "OrganisationUnitsList",
  components: {
    OrganisationUnitItem,
    BaseFooter,
    SecondaryButton,
    CreateUnitDialog,
    Permissioned,
    BaseAction
  },
  props: {
    searchText: String,
    isArchive: Boolean
  },
  created() {
    this.fetchUnits();
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ...mapOrganisationUnitsState(
      copyState(["organisationUnits", "archivedUnits", "isFetchingUnits"])
    ),
    filteredUnits() {
      const nestedOrganisationUnits = this.isArchive
        ? this.archivedUnits
        : getOrganisationsAsTreeStructure(this.organisationUnits);
      return filterDeep(nestedOrganisationUnits, this.searchText);
    }
  },
  methods: {
    ...mapOrganisationUnitsActions({
      fetchOrganisationUnits: FETCH_ORGANISATION_UNITS,
      fetchArchived: FETCH_ARCHIVED_UNITS
    }),
    fetchUnits() {
      this.isArchive
        ? this.fetchArchived({ filter: { archived: 1 } })
        : this.fetchOrganisationUnits();
    }
  }
};
</script>

<style scoped></style>
